import React from 'react'

import { PageTitle } from 'uiComponents/typography'
import SearchField from 'uiComponents/search/searchField'
import CartTable from './cartTable'
import ErrorBoundary from 'uiComponents/errorBoundary'
import CartFilters from './filters/searchAndDate'
import { Alert } from '@mui/material'
import { useHasFeature } from 'features'
import { SearchScopeBadge } from 'uiComponents/searchScopeBadge'
import './cartPage.scss'
import BaseKnowledgeLink from 'uiComponents/typography/BaseKnowledgeLink'
import { Trans, useTranslation } from 'translations'

const Cart: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    const isOpenReservationWarningShown = useHasFeature('show_open_reservation_hidden_warning')

    return (
        <div id="cart__elem">
            <PageTitle>{t('orders.cart.title')}</PageTitle>
            {isOpenReservationWarningShown && (
                <Alert severity="warning" sx={{ mb: 2 }}>
                    <Trans
                        i18nKey="orders.cart.openReservationWarning"
                        components={{ anchor: <a href="mailto:support@convious.com" /> }}
                    />
                </Alert>
            )}
            <div className="cart-filters-container">
                <SearchField placeholder={t('orders.cart.searchPlaceholder')} className="cart-search" />
                <SearchScopeBadge />
                <CartFilters />
            </div>
            <div>
                <CartTable />
            </div>
            <ErrorBoundary>{children}</ErrorBoundary>
            <BaseKnowledgeLink link="https://support.convious.com/help/pending-reservations" />
        </div>
    )
}

export default Cart
